import { AuthConfig } from 'angular-oauth2-oidc';

export const authCodeFlowConfig: AuthConfig = {
    clientId: import.meta.env.NG_APP_OIDC_RP_CLIENT_ID,
    issuer: import.meta.env.NG_APP_OIDC_OP_AUTHORIZATION_ENDPOINT,
    redirectUri: import.meta.env.NG_APP_LOGIN_REDIRECT_URL,
    responseType: 'code',
    scope: import.meta.env.NG_APP_OIDC_RP_SCOPES,
    showDebugInformation: true,
    tokenEndpoint: import.meta.env.NG_APP_OIDC_OP_TOKEN_ENDPOINT,
};
